<template>
  <section
    id="cover"
    class="te-bg-ordermade-cover bg-cover bg-bottom md:bg-center"
  >
    <div class="co-container-lg relative px-4 py-7 text-center">
      <div class="relative z-10">
        <div class="te-bg-orderamde-chach mb-4 inline-block rounded-lg p-4 md:p-7">
          <h1 class="te-ordermade-title mb-4 border-b-2 border-[#92E3E6] pb-3 font-bold leading-normal">
            オーダーメイドコース
          </h1>
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Cover/cover-catch-text.svg"
            alt="あなたに合わせたプランをご提案"
            class="mb-5 md:mb-6"
            width="423"
            height="120"
          >
          <a
            href="/counseling/htmlcss-schedule"
            class="bot_open co-btn-counseling rounded-full"
          >
            まずは無料相談
            <i
              class="fa fa-angle-right ml-2"
              aria-hidden="true"
            />
          </a>
        </div>
        <img
          src="~/assets/images/Te/TeCourse/Ordermade/Cover/cover-badge.svg"
          alt="学習スキル：20コース以上から組み合わせ、カスタイマイズ：自分にあった学習期間、受講料：ご予算に合わせてご提案"
          width="416"
          height="108"
          class="mx-auto mb-32 md:mb-0"
        >
      </div>
      <img
        src="~/assets/images/Te/TeCourse/Ordermade/Cover/cover-female.webp"
        class="te-cover-femal absolute bottom-0"
        width="306"
        height="321"
      >
      <picture class="te-cover-men absolute bottom-0 right-0">
        <source
          media="(min-width: 768px)"
          srcset="~/assets/images/Te/TeCourse/Ordermade/Cover/cover-men.webp"
        >
        <img
          src="~/assets/images/Te/TeCourse/Ordermade/Cover/cover-men-sp.webp"
          alt="男性"
          width="315"
          height="345"
        >
      </picture>
    </div>
  </section>
</template>

<style scoped>
.te-bg-ordermade-cover {
  background-image: url('~/assets/images/Te/TeCourse/Ordermade/Cover/bg-cover-sp.webp');
  @media (min-width: 768px) {
    background-image: url('~/assets/images/Te/TeCourse/Ordermade/Cover/bg-cover-pc.webp');
  }
}

.te-bg-orderamde-chach {
  background-color: rgba(255, 255, 255, 0.8);
}

.te-ordermade-title {
  font-size: 1.25rem;
  color: #00A7B4;
  @media (min-width: 768px) {
    font-size: 2rem;
  }
}

.te-cover-femal {
  bottom: 0;
  left: 18%;
  width: 6.6875rem;
  height: 7rem;
  @media (min-width: 768px) {
    left: 0;
    width: 19.125rem;
    height: 20.0625rem;
  }
}

.te-cover-men {
  right: 18%;
  bottom: 0;
  width: 5.6875rem;
  height: 7.25rem;
  @media (min-width: 768px) {
    right: 0;
    width: 19.6875rem;
    height: 21.5625rem;
  }
}
</style>
